import { Logo as BronsonLogo } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { currentBrand } from '../../config';

type LogoProps = {
    ariaLabel: string;
    title: string;
};

export const Logo: React.FC<LogoProps> = ({ title, ariaLabel }) => {
    return currentBrand !== 'df' ? (
        <BronsonLogo className={'u-block-center'} alt={title} ariaLabel={ariaLabel} title={title} />
    ) : (
        <a aria-label={ariaLabel} title={title}>
            <img
                src="/contents/df/logo_DutchFinance.svg"
                className={'u-1/3 u-1/2@s u-1/1@xs'}
                alt="DutchFinance Logo"
            />
        </a>
    );
};
